/**
 * El enlace de entrega en la URL: `#/entrega/<token>`.
 *
 * El token va en el fragmento y no en la ruta porque el navegador **no manda
 * el fragmento al servidor**: así no queda escrito en el log de nginx, ni en
 * el de la API, ni en el del proxy corporativo del cliente, que es por donde
 * pasa el pedido. De acá lo levanta la pantalla y lo manda en una cabecera.
 *
 * Está afuera de `App.tsx` para poder probarlo: es lo único que decide si
 * alguien sin usuario ve la pantalla de entrega o la de ingreso, y equivocarse
 * significa mandar al cliente a un login que no puede pasar.
 */
export function tokenDeEntrega(hash: string): string | null {
  const [vista, token, sobra] = hash.replace(/^#\/?/, '').split('/');
  if (vista !== 'entrega' || !token || sobra !== undefined) return null;

  // Un token viene de `randomBytes(...).toString('base64url')`: letras,
  // números, guión y guión bajo. Cualquier otra cosa es un link mal pegado o
  // alguien probando, y no hay por qué llevarlo a la pantalla para que el
  // servidor le diga lo mismo.
  const limpio = decodeURIComponent(token).trim();
  return /^[A-Za-z0-9_-]{20,200}$/.test(limpio) ? limpio : null;
}
